<template>
    <div class="allPage">
        <newHeader/>
        <div class="Box scrollbar" >
            <router-view class="content"/>
            <Footer class="footer"/>
        </div>
    </div>
</template>

<script>
    import newHeader from "../../components/showHeader/header";
    import Footer from "../../components/Footer";

    export default {
        name: "home",
        components: {
            newHeader,
            Footer
        },
    }
</script>

<style scoped lang="less">
    .allPage {
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow: auto;
        .Box {
            flex: 1;
            overflow: auto;
            /*display: flex;*/
            /*flex-direction: column;*/
            /*.content{*/
                /*flex: 1;*/
            /*}*/
        }

    }
</style>
